import { List, ListItem } from "@mui/material";
import { IRoutePartProps } from "./RouteDescription";
import { RoadFeaturesWithBruksklasse, SpesiellBegrensning } from "../../services/RuteplanAPI";


export function SpesielleBegrensningerMaksVogntogLengde(props: IRoutePartProps) {
    const roadFeatures = props.roadFeatures as RoadFeaturesWithBruksklasse;
    
    return (
        <>
            {roadFeatures && roadFeatures.spesielleBegrensningerMaksVogntogLengde && 
            <List>         
                {roadFeatures.spesielleBegrensningerMaksVogntogLengde.map( (begrensningerMaksVogntogLengde: SpesiellBegrensning, index: number) => {
                    return (
                        <ListItem 
                        key={`${begrensningerMaksVogntogLengde.attributeNote} - ${index}`} 
                        className="roadFeature"
                        onClick={(event) => {props.onClick(begrensningerMaksVogntogLengde, event)}}
                        onMouseEnter={() => props.onMouseEnterItem(begrensningerMaksVogntogLengde)}
                        onMouseLeave={props.onMouseLeaveItem}>
                            Begrensninger maks vogntoglengde: {begrensningerMaksVogntogLengde.attributeNote}                            
                        </ListItem>
                    )
                })}
            </List>
            }
        </>
    )
}